import React, { useEffect, useState } from "react";
import "../styles/About.css"; // Reuse existing banner styling
import CourseInfo from "../components/Course/CourseInfo";
import { useLocation, useParams } from "react-router-dom";
import { BASE_URL } from "../config/config"; // ✅ Correct import

const CourseDetail = () => {
  const { state } = useLocation();
  const { name } = useParams();

  const [course, setCourse] = useState(state?.course || null);
  const [loading, setLoading] = useState(!state?.course);

  useEffect(() => {
    setLoading(true);

    fetch(`${BASE_URL}/getCourseByName`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch course");
        return res.json();
      })
      .then((data) => {
        const formattedData = {
          ...data,
          price: JSON.parse(data.price || "[]"),
          final_rate: JSON.parse(data.final_rate || "[]"),
        };

        setCourse(formattedData);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, [name]);


  if (loading) {
    return <div className="text-center py-5">Loading...</div>;
  }

  if (!course) {
    return <div className="text-center py-5 text-danger">Course not found.</div>;
  }

  return (
    <>
      {/* Banner */}
      <section className="banner_area">
        <div className="banner_inner d-flex align-items-center">
          <div className="overlay bg-parallax"></div>
          <div className="container">
            <div className="banner_content text-center">
              <h2 className="fw-bold mb-3">
                {course.product_name || "Course Detail"}
              </h2>
              <div className="page_link">
                <a href="/">Home</a>
                <span className="breadcrumb-arrow">→</span>
                <a href="/courses">Courses</a>
                <span className="breadcrumb-arrow">→</span>
                <a href={`/course-detail/${name}`}>Course Detail</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pass the course prop */}
      <CourseInfo course={course} />
    </>
  );
};

export default CourseDetail;
